import { Link } from 'react-router-dom';

// Official Mashmari logo (180x60 transparent PNG). Only one variant was supplied,
// so on dark backgrounds it is placed on a white chip to keep the supplied colours readable.
export default function Logo({ variant = 'dark', className = '' }) {
  const img = (
    <img
      src="/mashmari-logo.png"
      alt="Mashmari — home"
      width={180}
      height={60}
      className="block h-9 md:h-10 w-auto"
    />
  );

  return (
    <Link to="/" aria-label="Mashmari home" data-testid="brand-logo-link"
      className={`inline-flex items-center group ${className}`}>
      {variant === 'light' ? (
        <span className="inline-flex items-center bg-white rounded-xl px-3 py-2 shadow-[0_10px_30px_-18px_rgba(0,0,0,.6)]">
          {img}
        </span>
      ) : img}
    </Link>
  );
}
